<template>

    <!--span style="cursor:pointer;" @click="openModal()" >{{ PointView.id }}</span-->
  
    <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId"  v-if="active">
            <div class="modal-dialog modal-lg" >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="editModalLabel"> 학습점수관리</h5>
    </div>
  
    <div class="modal-body">
      <table class="table">
        <tbody>
          <tr>
            <th>선택회원</th>
            <td style="text-align:center;">
              <input
                    type="text"
                    class="hidtype"                   
                    v-model="Psub.username"                   
                  />            
            </td>
            <th>유형</th>
            <td style="text-align:center;">
                <select class="hidtype" :value="nvl(changedData.chrGubun, Psub.chrGubun)"
                :class="{'hidtype-changed': changedData.chrGubun}"
                @input="doChange('chrGubun', $event.target.value)">
                <option value="P" selected>적립</option>
                <option value="M">차감</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>종류</th>
            <td style="text-align:center;">
                <select class="hidtype" :value="nvl(changedData.chrPType, Psub.chrPType)"
                :class="{'hidtype-changed': changedData.chrPType}"
                @input="doChange('chrPType', $event.target.value)">
                <option value="" selected>선택</option>
                <option value="A">ALPHA</option>
                <option value="C">CARAT</option>
                <option value="F">FAME</option>                
              </select>
            </td>
            <th>점수</th>
            <td style="text-align:center;">
              <select class="hidtype" :value="nvl(changedData.intPoint, Psub.intPoint)"
                :class="{'hidtype-changed': changedData.intPoint}"
                @input="doChange('intPoint', $event.target.value)">
                <option value="" selected>선택</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="2000">2000</option>
                <option value="3000">3000</option>
                <option value="5000">5000</option>
                <option value="">직접입력</option>
               </select>
            </td>
          </tr>
          <tr>
            <th>내용</th>
            <td colspan="3" style="text-align:center;">
              <input type="text" class="form-control" style='width:95%;margin-left:20px' placeholder="여기에 내용을 작성 .."
              v-model="this.Psub.strHistory" />
            </td>            
          </tr>          
        </tbody>
      </table>
  <div class="flex_center">
      <button type="button" class="btn btn-danger" @click="doSend()">수정</button>
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> Close</button>
    </div>
    </div></div>
  </div>
  </div>
  </template>
  
  <script>
  import axios from 'axios'
  export default {
      "name": "PointView",
      components: {
  
      },
      methods: {
        nvl(str, altStr){
          if(typeof str == "undefined" || str == null) str = altStr ;
           return str ;
  
        },
        openModal() {
          this.active = true;
          this.modifyMode(this.PointView)
          //console.log(this.Psub.bookclubs);
          this.$nextTick(function(){
            var modalDom = document.getElementById("Modal" + this.TbtnId);
            var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
            modalDom.addEventListener('hidden.bs#Modal', function (event) {
              this.active = false;
            })
            //console.log(modalDom);
            modal.show();
  
          });
        },
        doChange(name, value) {
          if (this.Psub[name] === value) {
            delete this.changedData[name];
          } else {
            this.changedData[name] = value;
          }
        },
        modifyMode(record){
          this.creating = false;
          this.changedData = {};
          this.Psub =  {
            "intNo": record.intNo,
            "chrGubun": record.chrGubun,
            "chrPType": record.chrPType            ,
            "intPoint": record.intPoint,
            "strHistory": record.strHistory,
            "intAdmin": record.intAdmin,            
          }
        },
        doSend() {
          // 업데이트일 경우 patch /businesses/번호
          // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
          var data = this.changedData;
  
          var send = {
            method: this.creating ? "post" : "patch",
            url: '/students/point' + "/" + this.Psub.intNo,
            data: data
          };
  
          //console.log(this.selBiz);
          //return;
  
              if(!this.active){
                  //if(!confirm("아무 기관도 선택하지 않았습니다. 이 관리아이디는 로그인 할 수 없게 됩니다. 의도한 동작이 맞을 경우에만 확인을 누르세요.")) return;
                  $.notify({
                    // options
                    message: '사용유무를 지정하셔야 합니다. '
                  }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                  });
                  return;
              }
  
            if(Object.keys(this.changedData).length){
  
            axios(send).then((response) => {
              if (response.data.error) {
                $.notify({
                  // options
                  message: '처리할 수 없습니다. ' + response.data.error
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
              } else {
                $.notify({
                  // options
                  message: '처리되었습니다'
                }, {
                  // settings
                  type: 'success',
                  z_index: 9999
                });
                //this.$refs.qg.search()
                this.$parent.search();
                (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();
              }
  
  
            })
  
            }
  
  
        }
      },
          mounted() {
        this.Psub = this.PointView;
        //console.log(this.Psub.bookclubs);
      },
      watch: {
        sub(){
          alert('Psub has been updated')
                this.Psub = this.PointView;
        }
      },
      props: {
        PointView: {
          type: Object,
          default: {}
        },
        btnId: String
      },
      data(){
          return {
              TbtnId: this.btnId || Math.random().toString().substr(2, 5),
              creating: false,
              active: false,
              Psub: {
                "studyNo": "",
                "name": "",
                "username": "",
                "id": "",
                "datStudy": "",
                "datPlan": "",
                "timeStudy": "",
                "intStudy": "",
                "bitComplete": ""
              },
              changedData: {
                // "studyNo": "",
                // "name": "",
                // "username": "",
                // "id": "",
                // "datStudy": "",
                // "datPlan": "",
                "timeStudy": "",
                "intStudy": "",
                "bitComplete": ""
              },
              product: null
          }
      }
  }
  </script>
  
  <style>
  
  </style>
P  